export const SET_AREA_LIST = 'SET_AREA_LIST';
export const SET_AREA = 'SET_AREA';
export const ADD_AREA = 'ADD_AREA';
export const UPDATE_AREA = 'UPDATE_AREA';
export const DELETE_AREA = 'DELETE_AREA';



// WEBPACK FOOTER //
// ./src/therapeuticArea/therapeuticAreaActionTypes.js